import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {stringify} from 'qs'
import {useEffect} from 'react'

import {ShiftTasksSummary, TaskSource} from '../types'

type Props = {
  plantId: string
  startDate?: string
  endDate?: string
}

const QueryKey = 'shift-tasks-plant-summary'

export const useShiftTasksSummary = (
  {plantId, startDate, endDate}: Props,
  options?: Omit<UseQueryOptions<ShiftTasksSummary, AxiosError>, 'queryKey' | 'queryFn'> & {
    onError?: (error: AxiosError) => void
  }
) => {
  const query = useQuery<ShiftTasksSummary, AxiosError>({
    queryKey: [QueryKey, plantId, startDate, endDate],
    queryFn: async ({signal}) => {
      const response = await ApiClient.axiosInstance.get<ShiftTasksSummary>(
        `/tasks/${plantId}/summary`,
        {
          params: {from: startDate, to: endDate, sources: [TaskSource.COCKPIT]},
          paramsSerializer: (params: string[]) => stringify(params, {arrayFormat: 'repeat'}),
          signal
        }
      )

      return response.data
    },
    ...options
  })

  const onError = options?.onError

  useEffect(() => {
    if (query.error) {
      onError?.(query.error)
    }
  }, [query.error, onError])

  return query
}
